'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ufunc = require('ufunc');

var _helpers = require('./helpers');

var _utility = require('./utility');

var _cuid = require('cuid');

var _cuid2 = _interopRequireDefault(_cuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var base = function base(Cmpt) {
  var UIKitBase = function (_React$Component) {
    _inherits(UIKitBase, _React$Component);

    function UIKitBase() {
      _classCallCheck(this, UIKitBase);

      return _possibleConstructorReturn(this, (UIKitBase.__proto__ || Object.getPrototypeOf(UIKitBase)).apply(this, arguments));
    }

    _createClass(UIKitBase, [{
      key: 'render',
      value: function render() {
        var props = this.props;
        var classes = [props.align ? (0, _helpers.getClass)(props.align, _utility.utilityCss.align) : null, props.borderRadius ? (0, _helpers.getClass)(props.borderRadius, _utility.utilityCss.borderRadius) : null, props.clear ? (0, _helpers.getClass)(props.clear, _utility.utilityCss.clear) : null, props.contrast ? 'uk-contrast' : null, props.col ? 'uk-width-1-1' : null, props.colSmall ? 'uk-width-1-1' : null, props.colMedium ? 'uk-width-1-1' : null, props.colLarge ? 'uk-width-1-1' : null, props.display ? (0, _helpers.getClass)(props.display, _utility.utilityCss.display) : null, props.float ? (0, _helpers.getClass)(props.float, _utility.utilityCss.float) : null, props.hidden ? (0, _helpers.getClasses)(props.hidden, _utility.utilityCss.hidden) : null, props.margin ? (0, _helpers.getClasses)(props.margin, _utility.utilityCss.margin) : null, props.order ? (0, _helpers.getClass)(props.order, _utility.utilityCss.order) : null, props.padding ? (0, _helpers.getClasses)(props.padding, _utility.utilityCss.padding) : null, props.position ? (0, _helpers.getClasses)(props.position, _utility.utilityCss.position) : null, props.responsive ? (0, _helpers.getClasses)(props.responsive, _utility.utilityCss.responsive) : null, props.scroll ? (0, _helpers.getClass)(props.scroll, _utility.utilityCss.scroll) : null, props.tall ? props.tall !== 'parent' ? _utility.utilityCss.tall : null : null, props.textAlign ? (0, _helpers.getClasses)(props.textAlign, _utility.utilityCss.textAlign) : null, props.textVertical ? (0, _helpers.getClasses)(props.textVertical, _utility.utilityCss.textVertical) : null, props.textWrap ? (0, _helpers.getClasses)(props.textWrap, _utility.utilityCss.textWrap) : null, props.vertical ? (0, _helpers.getClass)(props.vertical, _utility.utilityCss.vertical) : null, props.viewport ? 'uk-height-viewport' : null, props.visible ? (0, _helpers.getClasses)(props.visible, _utility.utilityCss.visible) : null, props.wide ? props.wide !== 'parent' ? _utility.utilityCss.tall : null : null];

        var containerClasses = (0, _helpers.cleanClasses)([props.center ? _utility.utilityCss.center : null, props.col ? 'uk-width-' + props.col : null, props.colSmall ? 'uk-width-small-' + props.colSmall : null, props.colMedium ? 'uk-width-medium-' + props.colMedium : null, props.colLarge ? 'uk-width-large-' + props.colLarge : null, props.vertical ? 'uk-vertical-align' : null, props.tall ? props.tall === 'parent' ? _utility.utilityCss.tall : null : null, props.wide ? props.wide === 'parent' ? _utility.utilityCss.tall : null : null]);

        var kitid = props.kitid || (0, _cuid2.default)();

        // Elementd
        var component = _react2.default.createElement(Cmpt, _extends({}, this.props, { kitid: kitid, classes: (0, _ufunc.cleanAll)(classes) }));

        var list = (0, _ufunc.maybeIf)(_react2.default.createElement(
          'li',
          { className: containerClasses },
          component
        ))(props.list);

        var container = (0, _ufunc.maybeIf)(_react2.default.createElement(
          'div',
          { className: containerClasses },
          component
        ))((0, _ufunc.someTrue)(props.center, props.col, props.colSmall, props.colMedium, props.colLarge, props.vertical));

        // return component
        return list || container || component;
      }
    }]);

    return UIKitBase;
  }(_react2.default.Component);

  UIKitBase.propTypes = {
    align: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('align')),
    children: _react2.default.PropTypes.any,
    className: _react2.default.PropTypes.string,
    borderRadius: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('borderRadius')),
    clear: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('clear')),
    center: _react2.default.PropTypes.bool,
    col: _react2.default.PropTypes.oneOf(_helpers.colSpan),
    colSmall: _react2.default.PropTypes.oneOf(_helpers.colSpan),
    colMedium: _react2.default.PropTypes.oneOf(_helpers.colSpan),
    colLarge: _react2.default.PropTypes.oneOf(_helpers.colSpan),
    contrast: _react2.default.PropTypes.bool,
    display: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('display')),
    float: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('float')),
    hidden: _react2.default.PropTypes.string,
    kitid: _react2.default.PropTypes.string,
    margin: _react2.default.PropTypes.string,
    order: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('order')),
    padding: _react2.default.PropTypes.string,
    position: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('position')),
    responsive: _react2.default.PropTypes.string,
    scroll: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('scroll')),
    tall: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string]),
    textAlign: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textAlign')),
    textVertical: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textVertical')),
    textWrap: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textWrap')),
    vertical: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('vertical')),
    viewport: _react2.default.PropTypes.bool,
    visible: _react2.default.PropTypes.string,
    wide: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string])
  };

  return UIKitBase;
};

exports.default = base;


//////////////////
// WEBPACK FOOTER
// ./~/react-uikit-base/lib/base.js
// module id = 577
// module chunks = 0